var _desc, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPort = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Amazon Web Service Internet Of Thing Event Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M2.75 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4M8.35 6.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4M8.35 21.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4M20.85 16.9c-1 .7-2.2 1.1-3.5 1.1-1.9 0-3.5-.8-4.6-2.2M22.75 9.6c.3.7.5 1.6.5 2.4M12.75 8.1c1.1-1.3 2.7-2.1 4.5-2.1 1.2 0 2.3.3 3.2.9M17.367 15.407c-1.931 0-3.407-1.476-3.407-3.407 0-1.93 1.476-3.407 3.406-3.407s3.407 1.476 3.407 3.407h2.446M13.885 12H4.75M9.85 5.8l2.9 2.3M9.85 18.2l2.9-2.4M22.75 14.5c.3-.7.5-1.6.5-2.4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  d: "M17.385 13.089a1.089 1.089 0 1 0 0-2.178 1.089 1.089 0 0 0 0 2.178"
})));
export { SvgPort as ReactComponent };
export default __webpack_public_path__ + "assets/images/port.svg";